import React from 'react'
import ReactDOM from 'react-dom'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'

import App from './App'
import rootReducer, { defaultState } from './reducers'

export const startApp = coursenum => {
  const middleware =
    process.env.NODE_ENV !== 'production'
      ? applyMiddleware(thunk, createLogger())
      : applyMiddleware(thunk)
  const store = createStore(
    rootReducer,
    { ...defaultState, coursenum },
    middleware
  )
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('App')
  )
}
